import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  policyList: { data: [], total: 0 },
  policyStatusOptions: [],
};

const policiesSlice = createSlice({
  name: "policySlice",
  initialState,
  reducers: {
    policyList(state, action) {
      const payload = action.payload;
      state.policyList = Array.isArray(payload)
        ? { data: payload, total: payload.length }
        : payload || { data: [], total: 0 };
    },
    setPolicyStatusList(state, action) {
      const payload = action.payload;
      state.policyStatusOptions = Array.isArray(payload)
        ? payload.map((status: any) => ({
            value: status.id ?? status.value,
            label: status.name ?? status.label,
          }))
        : [];
    },
  },
});

export const { policyList, setPolicyStatusList } = policiesSlice.actions;
export default policiesSlice.reducer;
